import { Chip, Rv } from '../../components'
import { LOGOS }    from '../../constants/logos'

export function EducationSection() {
  const edu = [
    { period: 'Mar 2026 — Present', logo: LOGOS.monash, alt: 'Monash University',            href: 'https://monash.edu',  degree: 'Master of Information Technology',  field: 'Artificial Intelligence & Quantum Computing', school: 'Monash University · Clayton, Australia',          tags: ['AI', 'Machine Learning', 'Deep Learning', 'Quantum Computing', 'Quantum Algorithms'], v: true,  note: null },
    { period: 'Graduated May 2023', logo: LOGOS.lpu,    alt: 'Lovely Professional University',href: 'https://lpu.in',     degree: 'Bachelor of Technology',           field: 'Computer Science & Engineering',              school: 'Lovely Professional University · Jalandhar, India',tags: ['Software Testing', 'SDLC', 'DBMS', 'Java', 'OOPs', 'DSA'],                           v: false, note: 'Major: Data Science · Minor: Robotic Process Automation' },
  ]
  return (
    <section id="education" className="sec">
      <div className="wrap">
        <Rv className="sh"><div className="slb">Education</div><h2 className="st">Academic Foundation</h2><div className="gbar"/></Rv>
        <div className="eg-grid">
          {edu.map((e, i) => (
            <Rv key={e.degree} delay={i * 0.18} className="gls ec">
              <div className="eperiod">{e.period}</div>
              <a href={e.href} target="_blank" rel="noopener" className="logo-wrap"><img src={e.logo} alt={e.alt}/></a>
              <div className="edeg">{e.degree}</div>
              <div className="efd">{e.field}</div>
              <div className="esc">{e.school}</div>
              {e.note && <div className="esc" style={{ marginTop: '-.5rem', color: 'var(--cy)', fontWeight: 600 }}>{e.note}</div>}
              <div className="chips">{e.tags.map(t => <Chip key={t} label={t} v={e.v}/>)}</div>
            </Rv>
          ))}
        </div>
      </div>
    </section>
  )
}
